import { render } from "./WorkPreferences.vue?vue&type=template&id=4fd9f511&scoped=true"
import script from "./WorkPreferences.vue?vue&type=script&lang=js"
export * from "./WorkPreferences.vue?vue&type=script&lang=js"

import "./WorkPreferences.vue?vue&type=style&index=0&id=4fd9f511&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd9f511"]])

export default __exports__